import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ClienteService } from '../services/cliente.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(authService, router, clienteService) {
        this.authService = authService;
        this.router = router;
        this.clienteService = clienteService;
        this.usuario = {
            password: null,
            username: null
        };
        this.alert = {
            tipo: "danger",
            titulo: "Verifique",
            mensaje: "El usuario o la contraseña no son válidos.",
            visible: false
        };
    }
    LoginComponent.prototype.ngOnInit = function () {
    };
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        this.authService.login(this.usuario.username, this.usuario.password).subscribe(function (result) {
            if (result === true) {
                // login successful
                if (_this.authService.roles.indexOf("administrador") > -1) {
                    _this.router.navigate(['dashboard/clientes']);
                }
                else if (_this.authService.roles.indexOf("usuario") > -1) {
                    _this.router.navigate(['clientes']);
                }
                else if (_this.authService.roles.indexOf("intranet") > -1) {
                    _this.router.navigate(['intranet/kairos']);
                }
            }
            else {
                // login failed                    
                _this.alert.visible = true;
                _this.alert.closed = false;
                _this.alert.tipo = "danger";
                _this.alertComponent.setType(_this.alert.tipo);
            }
        }, function (error) {
            _this.alert.visible = true;
            _this.alert.closed = false;
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
        });
    };
    LoginComponent.ctorParameters = function () { return [{ type: AuthService }, { type: Router }, { type: ClienteService }]; };
    return LoginComponent;
}());
export { LoginComponent };
//# sourceMappingURL=login.component.js.map


// WEBPACK FOOTER //
// login.component.js